exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title2 {\r\n  font-size: 18px;\r\n}\r\n\r\n.title-description {\r\n    font-size: 12px;\r\n}\r\n\r\n.report-block {\r\n  margin: 10px;\r\n}\r\n\r\n.reset-btn {\r\n  margin-left: .5%;\r\n  height: 40%;\r\n  color: black;\r\n  background-color: white;\r\n}\r\n\r\n.submit-btn {\r\n  margin-left: 1%;\r\n  height: 40%;\r\n  background-color: #115E67;\r\n  border-color: transparent;\r\n}\r\n\r\n.default-btn {\r\n  background-color: white;\r\n  border: 1px solid rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.responsive {\r\n  overflow-x: scroll;\r\n}\r\n\r\n.table td {\r\n  font-size: 11px;\r\n  padding: 6px;\r\n  vertical-align: top;\r\n  border-top: 1px solid #eceeef;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.css
// module id = 349
// module chunks = 1